<template>
    <span 
        :style="{
            'text-decoration': 'underline',
            'color': selectColor(this.textColor) + ' !important',
            'font-family': `var(--${fontFamily}) !important`,
            'font-weight': fontWeight + ' !important'
        }"
    >
        <span :style="{'padding-right': icon ? textPr : 0}">
            {{ text }}
        </span>
        <i v-if="icon" class="pi" :class="[icon]" :style="{'width': iconWidth, 'height': iconHeight, 'background': selectColor(this.iconColor)}"></i>
    </span>
</template>
<script>
export default {
    name: 'ShowText',
    props: {
        text: {
            type: String,
            default: 'text'
        },
        fontFamily: {
            type: String,
            default: 'font-acumin-pro-semibold'
        },
        fontWeight: {
            type: String,
            default: 'normal'
        },
        textPr: {
            type: String,
            default: '8px' 
        },
        textColor: {
            type: String,
            default: 'secondary'
        },
        icon: {
            type: String
        },
        iconColor: {
            type: String,
            default: 'primary'
        },
        iconWidth: {
            type: String,
            default: '22px',
        },
        iconHeight: {
            type: String,
            default: '14px'
        }
    },
    methods: {
        selectColor(val) {
            let value = ''
            switch (val) {
                case 'primary':
                    value = 'var(--iu-main)'
                    break;
                case 'secondary':
                    value = 'var(--iu-secondary)'
                    break;
                case 'tertiary':
                    value = 'var(--iu-tertiary)'
                    break;
                default:
                    break;
            }
            return value
        },
    }
}
</script>